var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};



//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/~/core-js/modules/_shared.js
// module id = ../../../../core-js/modules/_shared.js
// module chunks = 0